module.exports = __webpack_public_path__ + "static/whoami-20631e6d475c01ca797b9ca60e95ad55.jpg";